<template>
  <div class="newwarp boxsizing miniwarp gray80">
    <div class="auto">
      <page-title title="新增" icon="fa-user-circle"></page-title>
    </div>
    <el-row class="m-t-15">
      <el-col :span="24">
        <div class="padding-15">
          <dufault-column height="auto" title="用户新增" tooltip="所选时间段内用户增长情况。<br/>以近一个月为默认统计时间，公众号账号内新增用户相关的整体数据呈现，可自行选择时间维度查看数据，最多可选取180天。<br/>支持按日、周、月、季不同维度查看。<br/>顶部为该公众号新增数据，包含关注用户数、取关用户数、限时取关用户数三个关键指标呈现。<br/>鼠标放在“?”处，可查看对应数据名称的详细注释；<br/>鼠标放在图表上，可查看单日/周/月/季数据详情。" v-loading="loading">
            <div slot="bar">
              <dates-picker v-model="hDate" size="mini" style="margin-right:15px;"></dates-picker>
              <el-radio-group v-model="interval" size="mini">
                <el-radio-button :label="item.value" v-for="(item, index) in options" :key="index">{{item.label}}</el-radio-button>
              </el-radio-group>
            </div>
            <div slot="content">
              <el-row>
                <el-col :span="8">
                  <div class="flex-box auto">
                    <div class="useraddbox auto">
                      关注用户数
                      <el-tooltip class="item" effect="dark" content="所选时间段内关注用户数。" placement="top">
                        <i class="fa fa-question-circle-o gray80 font14"></i>
                      </el-tooltip>
                      <p>{{util.numberFormat(header.sub_user || 0)}}</p>
                    </div>
                    <div class="useraddbox auto">
                      取关用户数
                      <el-tooltip class="item" effect="dark" content="公众账号接入平台后，所选时间段内取消关注的用户数。" placement="top">
                        <i class="fa fa-question-circle-o gray80 font14"></i>
                      </el-tooltip>
                      <p>{{util.numberFormat(header.unsub_user || 0)}}</p>
                    </div>
                  </div>
                  <div class="flex-box auto">
                    <div class="useraddbox auto">
                      限时取关用户数
                      <el-tooltip class="item" effect="dark" content="公众号接入平台后，所选时间段内关注过且已经取消关注的用户数。" placement="top">
                        <i class="fa fa-question-circle-o gray80 font14"></i>
                      </el-tooltip>
                      <p>{{util.numberFormat(header.sub_unsub_user || 0)}}</p>
                    </div>
                  </div>
                </el-col>
                <el-col :span="16">
                  <echarts :data="chartData1" title="" height="270" :nohader="true"></echarts>
                  <!-- <p class="morep">
                    <a href="javascript:;" @click="openDialog" class="alink font12">查看更多>></a>
                  </p> -->
                </el-col>
              </el-row>
            </div>
          </dufault-column>
        </div>
      </el-col>
    </el-row>
    <!-- <el-row class="m-t-15">
      <el-col :span="24" align="right">
        <dates-picker v-model="hDate2" size="small"></dates-picker>
      </el-col>
    </el-row> -->
    <el-row class="m-t-15">
      <el-col :span="24">
        <div>
          <dufault-column height="auto" title="关注二维码" tooltip="所选时间段内用户关注来源情况。<br/>以近一个月为默认统计时间，统计该公众号内二维码关注及取关人数，可自行选择时间维度查看数据，最多可选取180天。<br/>鼠标放在“?”处，可查看对应数据名称的详细注释；<br/>鼠标放在图表上，可查看某二维码来源新增用户数及占比。" v-loading="loadingBot">
            <div slot="bar">
              <dates-picker v-model="hDate2" size="mini"></dates-picker>
              <!-- <el-radio-group v-model="interval2" size="mini">
                <el-radio-button :label="item.value" v-for="(item, index) in options" :key="index">{{item.label}}</el-radio-button>
              </el-radio-group> -->
            </div>
            <div slot="content">
              <el-row>
                <el-col :span="8">
                  <echarts :data="chartData2" title="" height="300" :nohader="true"></echarts>
                </el-col>
                <el-col :span="16">
                  <el-table :data="totalData2" @sort-change="sortChange2" style="width: 100%;margin-bottom: 20px;">
                    <!-- <el-table-column prop="name" :label="getType(type)"> -->
                    <el-table-column prop="name" label="二维码">
                      <template slot-scope="scope">
                        <el-button type="text" size="small" @click="getUserAttrDetail(scope.row)">{{scope.row.name}}</el-button>
                        <!-- {{scope.row.name}} -->
                      </template>
                    </el-table-column>
                    <el-table-column prop="sub" sortable label="新增粉丝数">
                      <template slot-scope="scope">
                        {{util.numberFormat(scope.row.sub)}}
                      </template>
                    </el-table-column>
                    <el-table-column prop="unsub" sortable label="取关粉丝数">
                      <template slot-scope="scope">
                        {{util.numberFormat(scope.row.unsub)}}
                      </template>
                    </el-table-column>
                  </el-table>
                  <div class="pageBox" v-if="tableData2.length > pageSize">
                    <el-pagination
                      layout="prev, pager, next"
                      :page-size="pageSize"
                      @current-change="tablePage2"
                      :current-page.sync="page2"
                      :total="tableData2.length"
                      align="right">
                    </el-pagination>
                  </div>
                </el-col>
              </el-row>
            </div>
          </dufault-column>
        </div>
      </el-col>
    </el-row>
    <el-row class="m-t-15">
      <el-col :span="24">
        <div>
          <dufault-column height="auto" title="关注来源 " tooltip="以近一个月为默认统计时间，统计该公众号内不同关注方式关注及取关人数，可自行选择时间维度查看数据，最多可选取180天。" v-loading="loadingBot2">
            <div slot="bar">
              <dates-picker v-model="hDate3" size="mini"></dates-picker>
              <!-- <el-radio-group v-model="interval3" size="mini">
                <el-radio-button :label="item.value" v-for="(item, index) in options" :key="index">{{item.label}}</el-radio-button>
              </el-radio-group> -->
            </div>
            <div slot="content">
              <el-row>
                <el-col :span="8">
                  <echarts :data="chartData3" title="" height="300" :nohader="true"></echarts>
                </el-col>
                <el-col :span="16">
                  <el-table :data="totalData3" @sort-change="sortChange3" style="width: 100%;margin-bottom: 20px;">
                    <!-- <el-table-column prop="name" :label="getType(type)"> -->
                    <el-table-column prop="name" label="来源">
                      <template slot-scope="scope">
                        <el-button type="text" size="small" @click="getUserAttrDetail2(scope.row)">{{scope.row.name}}</el-button>
                        <!-- {{scope.row.name}} -->
                      </template>
                    </el-table-column>
                    <el-table-column prop="sub" sortable label="新增粉丝数">
                      <template slot-scope="scope">
                        {{util.numberFormat(scope.row.sub)}}
                      </template>
                    </el-table-column>
                    <el-table-column prop="unsub" sortable label="取关粉丝数">
                      <template slot-scope="scope">
                        {{util.numberFormat(scope.row.unsub)}}
                      </template>
                    </el-table-column>
                  </el-table>
                  <div class="pageBox" v-if="tableData3.length > pageSize">
                    <el-pagination
                      layout="prev, pager, next"
                      :page-size="pageSize"
                      @current-change="tablePage3"
                      :current-page.sync="page3"
                      :total="tableData3.length"
                      align="right">
                    </el-pagination>
                  </div>
                </el-col>
              </el-row>
            </div>
          </dufault-column>
        </div>
      </el-col>
    </el-row>
    <detail-dialog title="用户增长详情" :status="dialogStatus" :chartData="dialogChart" :dialogVisible="dialogVisible" :tableHead="tableHead" :tableData="tableData" @tableSortChange="tableSortChange" @visibleFn="visibleFn">
      <div slot="bar" style="text-align: right; padding: 15px;">
        <dates-picker v-model="dialogDate" size="small" style="margin-right:15px;position: relative; top: 2px;"></dates-picker>
        <el-radio-group v-model="interval2" size="small">
          <el-radio-button :label="item.value" v-for="(item, index) in options" :key="index">{{item.label}}</el-radio-button>
        </el-radio-group>
      </div>
    </detail-dialog>
  </div>
</template>
<script>
import { Data as DataModel } from '@/model'
import { Data as DataController } from '@/controller'
export default {
  data () {
    return {
      loadingBot2: false,
      loadingBot: false,
      loading: false,
      hDate: this.util.getDataPickerDefault(),
      hDate2: this.util.getDataPickerDefault(),
      hDate3: this.util.getDataPickerDefault(),
      dialogDate: this.util.getDataPickerDefault(),
      dialogStatus: true,
      dialogVisible: false,
      dialogChart: {},
      header: {},
      chartData1: {},
      chartData2: {},
      chartData3: {},
      interval: 'week',
      interval2: 'week',
      interval3: 'week',
      options: [
        {
          value: 'day',
          label: '日'
        },
        {
          value: 'week',
          label: '周'
        },
        {
          value: 'month',
          label: '月'
        },
        {
          value: 'quarter',
          label: '季'
        }
      ],
      tableLoading: false,
      tableHead: [
        {
          title: '日期',
          tag: 'name',
          sort: true
        },
        {
          title: '新增粉丝数',
          tag: 'sub',
          sort: true,
          thousand: true
        },
        {
          title: '取关粉丝数',
          tag: 'unsub',
          sort: true,
          thousand: true
        }
      ],
      pageSize: 5,
      page2: 1,
      page3: 1,
      tableData: [],
      totalData2: [],
      tableData2: [],
      totalData3: [],
      tableData3: [],
      type: 'qr_scene',
      titleOptions: [
        {
          value: 'qr_scene',
          label: '二维码来源'
        },
        {
          value: 'subscribe_scene',
          label: '关注方式'
        }
      ]
    }
  },
  watch: {
    'dialogDate': function (val, oldval) {
      if (this.dialogVisible) {
        if (this.type === 'qr_scene') {
          this.getUserAttrDetail(this.row)
        } else {
          this.getUserAttrDetail2(this.row)
        }
      }
    },
    'interval2': function (val, oldval) {
      if (this.dialogVisible) {
        if (this.type === 'qr_scene') {
          this.getUserAttrDetail(this.row)
        } else {
          this.getUserAttrDetail2(this.row)
        }
      }
    },
    'hDate': function (val) {
      this.getUserTotalByDate()
    },
    'interval': function (val) {
      this.getUserTotalByDate()
    },
    'hDate2': function (val) {
      this.type = 'qr_scene'
      this.getUserSceneByDate()
    },
    'hDate3': function (val) {
      this.type = 'subscribe_scene'
      this.getUserSceneByDate2()
    },
    'type': function (val) {
      if (val === 'qr_scene') {
        this.page2 = 1
        this.tablePage2(1)
      } else {
        this.page3 = 1
        this.tablePage3(1)
      }
    }
  },
  methods: {
    sortChange3 (column) {
      var tableData2 = this.tableData3
      this.util.arraySort(tableData2, column['prop'], column['order'])
      this.tablePage3(1)
      this.page3 = 1
      this.tableData3 = tableData2
    },
    tablePage3 (val) {
      this.totalData3 = []
      this.tableData3.filter((item, index) => {
        var max = val * this.pageSize
        var min = (val - 1) * this.pageSize
        if (index >= min && index < max) {
          this.totalData3.push(item)
        }
      })
    },
    sortChange2 (column) {
      var tableData2 = this.tableData2
      this.util.arraySort(tableData2, column['prop'], column['order'])
      this.tablePage2(1)
      this.page2 = 1
      this.tableData2 = tableData2
    },
    tablePage2 (val) {
      this.totalData2 = []
      this.tableData2.filter((item, index) => {
        var max = val * this.pageSize
        var min = (val - 1) * this.pageSize
        if (index >= min && index < max) {
          this.totalData2.push(item)
        }
      })
    },
    getType (type) {
      var title = ''
      this.titleOptions.map((item) => {
        if (item.value === type) {
          title = item.label
        }
      })
      return title
    },
    async getUserAttrDetail (row, sort) {
      this.type = 'qr_scene'
      this.row = row
      if (!this.dialogVisible && String(this.dialogDate) !== String(this.hDate2)) {
        this.dialogDate = this.hDate2
      }
      this.dialogVisible = true
      this.dialogStatus = !this.dialogStatus
      let res = await DataModel.User.getUserSceneDetailByDate({
        qrcode_id: String(row.key),
        interval: this.interval2,
        begin_time: this.dialogDate[0],
        end_time: this.dialogDate[1]
      })
      this.dialogChart = DataController.User.attributeBarAndLine(res['data'] || '')
      this.tableData = res['data'] || []
    },
    async getUserAttrDetail2 (row, sort) {
      this.type = 'subscribe_scene'
      this.row = row
      if (!this.dialogVisible && String(this.dialogDate) !== String(this.hDate3)) {
        this.dialogDate = this.hDate3
      }
      this.dialogVisible = true
      this.dialogStatus = !this.dialogStatus
      let res = await DataModel.User.getUserSubscribeSceneDetailByDate({
        subscribe_scene: String(row.key),
        interval: this.interval2,
        begin_time: this.dialogDate[0],
        end_time: this.dialogDate[1]
      })
      this.dialogChart = DataController.User.attributeBarAndLine(res['data'] || '')
      this.tableData = res['data'] || []
    },
    openDialog () {
      this.dialogDate = Object.assign([], this.hDate)
      this.dialogVisible = true
    },
    visibleFn (val) {
      this.dialogVisible = val
    },
    tableSortChange (column) {
      var tableData = this.tableData
      this.util.arraySort(tableData, column['prop'], column['order'])
      this.tableData = tableData
    },
    async getUserTotalByDate () {
      this.loading = true
      let res = await DataModel.User.getUserTotalByDate({
        begin_time: this.hDate[0],
        end_time: this.hDate[1],
        interval: this.interval
      })
      if (!res['err_code']) {
        this.header = res['data'] || {}
        this.chartData1 = DataController.User.overviewBarAndLine(this.header['date_interval'] || '')
      }
      this.loading = false
    },
    async getUserSceneByDate () {
      this.loadingBot = true
      let res = await DataModel.User.getUserSceneByDate({
        begin_time: this.hDate2[0],
        end_time: this.hDate2[1]
      })
      if (!res['err_code']) {
        this.tableData2 = res['data']['qr_scene'] || []
        this.tablePage2(1)
        let chartData = res['data']['qr_scene']
        if (chartData) {
          let data = {}
          chartData.slice(0, 5).map(item => {
            data[item['name']] = item['sub']
          })
          chartData = data
        } else {
          chartData = ''
        }
        this.chartData2 = DataController.User.attributePie(chartData)
      }
      this.loadingBot = false
    },
    async getUserSceneByDate2 () {
      this.loadingBot2 = true
      let res = await DataModel.User.getUserSceneByDate({
        begin_time: this.hDate3[0],
        end_time: this.hDate3[1]
      })
      if (!res['err_code']) {
        this.tableData3 = res['data']['subscribe_scene'] || []
        this.tablePage3(1)
        let chartData2 = res['data']['subscribe_scene']
        if (chartData2) {
          let data = {}
          chartData2.slice(0, 5).map(item => {
            data[item['name']] = item['sub']
          })
          chartData2 = data
        } else {
          chartData2 = ''
        }
        this.chartData3 = DataController.User.attributePie(chartData2)
      }
      this.loadingBot2 = false
    }
  },
  created () {
    this.getUserTotalByDate()
    this.getUserSceneByDate()
    this.getUserSceneByDate2()
  },
  mounted () {
  }
}
</script>
<style scoped>
.benchmarkbox {
  padding-right: 20px;
}
.benchmarkbox p {
  color: #ef8e2f;
  margin: 35px 0 30px;
}
.benchbox {
  flex: 1;
  margin: 0 30px 30px;
  padding: 30px 0;
  border-bottom: 2px solid #ef8e2f;
  text-align: center;
}
.benchbox2 {
  border-color: #6cb12c;
}
.benchbox3 {
  border-color: #39a6fc;
}
.benchbox4 {
  border-color: #58e1c2;
}
.benchbox5 {
  border-color: #b961fc;
}
.benchbox p {
  font-size: 30px;
  font-weight: 300;
  margin-top: 30px;
}

.usercountbox {
  padding-right: 30px;
}
.usercountbox p {
  margin: 85px 0 50px;
}
.usercountbox span {
  font-weight: 300;
}
.nobor {
  border: none;
  margin-bottom: 0px;
}

.useraddbox {
  flex: 1;
}
.useraddbox p {
  font-size: 30px;
  font-weight: 300;
  padding: 20px 0 30px;
}
.nopadbotbox .useraddbox p {
  padding-bottom: 0;
}
.morep {
  text-align: right;
}
</style>
